/* eslint-disable */
import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import {Link} from 'react-router-dom';
import {Elements} from 'react-stripe-elements';
import {StyleSheet, css} from 'aphrodite';
import Modal from 'react-modal';

import {updateAppState} from '../../actions/applicationState';
import {updateUser, updateUserRemote} from '../../actions/user';

import {Theme} from '../../config/theme';

import Button from '../Button';

const CLOSE_ICON = require('./close.svg');

let styles;

export default class CancelSubscriptionModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      error: null,
    };
  }

  handleClose() {
    this.props.closeHandler();
  }

  submit() {
    this.props.dispatch(updateAppState({
      loading: true,
    }));

    this.props.dispatch(updateUserRemote({
      renew_membership: false,
      card_token: null,
      last4: null,
    }, this.props.user.access_token)).then((response) => {
      this.props.dispatch(updateAppState({
        loading: false,
      }));

      this.props.closeHandler();
    }, (err) => {
      this.props.dispatch(updateAppState({
        loading: false,
      }));

      this.props.closeHandler();
    });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        className={css(styles.container)}
        onRequestClose={this.handleClose}
        style={{
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.67)',
            zIndex: 101,
            display: 'flex',
          },
        }}
        contentLabel="Cancel subscription"
      >
        <div className={css(styles.modal_wrapper)}>
          <div className={css(styles.header)}>
            <h2 className={css(styles.title)}>Cancel your resubscription</h2>
            <div
              className={css(styles.close_icon)}
              onClick={this.handleClose}
              role="button"
              tabIndex={0}
            >
              <img src={CLOSE_ICON} alt="Close modal"/>
            </div>
          </div>
          <div className={css(styles.body)}>
            <div className={css(styles.text)}>
              We know dog needs change across life, so we have made it easy for you to come and go. By cancelling your
              planned resubscription today, your current subscription term will auto-expire on its one year anniversary.
              To re-join after this date simply log in using your email address and password and add a payment method.
              Or if there is anything else we can help you with before or after you depart, <Link to="/contact">get in touch</Link>. We're here for
              good!
            </div>
            <hr/>
            <div className={css(styles.button_container)}>
              <Button
                title="Cancel my resubscription"
                styles={styles.button}
                handler={this.submit.bind(this)}/>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

CancelSubscriptionModal.propTypes = {
  open: PropTypes.bool,
  closeHandler: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
};

CancelSubscriptionModal.defaultProps = {
  open: false,
  closeHandler: () => {
  },
};

styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    height: 450,
    maxHeight: '100vh',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',

    [Theme.mobile_query]: {
      width: '95%',
      height: 'auto',
    },
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 500,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 60px',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: '0 30px',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '50px 0px',
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: '900',
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  full_width_button: {
    width: '100%',
  },
  button: {
    width: '100%',
  },
  body: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  seperator_container: {
    display: 'flex',
    height: 25,
    margin: '25px auto',
    alignItems: 'center',
    justifyContent: 'center',
    ':after': {
      content: "' '",
      position: 'absolute',
      width: '100%',
      height: 1,
      backgroundColor: Theme.horizontal_rule_color,
    },
  },
  text: {
    fontFamily: Theme.font_family_primary,
    textAlign: 'center',
    marginBottom: 10,
    lineHeight: '21px',
  },
  seperator_text: {
    fontFamily: Theme.font_family_primary,
    backgroundColor: Theme.white,
    zIndex: 10,
    padding: 15,
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  footer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 0,
    height: 100,
    width: '100%',
    backgroundColor: Theme.light_grey,

    [Theme.mobile_query]: {
      position: 'relative',
      height: 'auto',
      marginTop: 30,
      padding: '30px',
      textAlign: 'center',
    },
  },
  sign_up_container: {
    fontFamily: Theme.font_family_primary,
    fontSize: 16,
    textAlign: 'center',
  },
  sign_up_link: {
    display: 'inline',
    fontFamily: Theme.font_family_secondary,
    letterSpacing: 1,
    marginLeft: 5,
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  forgotten_password: {
    flex: 1,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    textAlign: 'center',
  },
  login_button_container: {
    flex: 1,
  },
  clippy: {
    marginLeft: 20,
  },
  copy_button: {
    backgroundColor: 'transparent',
    padding: '10px 20px',
    boxSizing: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    transition: 'all ease-out 160ms',
    cursor: 'pointer',
    border: 'none',
  },
  copy_button_container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: Theme.primary,
    fontSize: 13,
    fontWeight: 'bold',
  },
  button_container: {
    marginTop: 40,
    marginBottom: 20,

    [Theme.mobile_query]: {
      justifyContent: 'center',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/CancelSubscriptionModal/index.js